<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane ref="departmentPane" directory-scope="internal" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" row-key="Id" v-loading="listLoading" @selection-change="handleSelectionChange" @row-click="handleRowClick" ref="table"
        class="custom-tbl teacher-table" height="100%" style="width: 100%">
        <el-table-column type="selection" width="48" />

        <el-table-column label="教师" min-width="200">
          <template slot-scope="{ row }">
            <div class="teacher-identity">
              <div class="teacher-avatar">
                <oss-media-thumbs
                  v-if="row.HeadPhotoImage"
                  :media="row.HeadPhotoImage"
                  thumb-width="40px"
                  thumb-height="40px"
                />
                <span v-else class="teacher-avatar-fallback">{{ teacherNameInitial(row.TeacherName) }}</span>
              </div>
              <div class="teacher-identity-text">
                <div class="teacher-name-row">
                  <strong>{{ row.TeacherName || '-' }}</strong>
                  <el-tag
                    v-if="hasKnownSex(row.Sex)"
                    size="mini"
                    effect="plain"
                    :type="sexTagType(row.Sex)"
                  >{{ formatSex(row) }}</el-tag>
                </div>
                <div class="teacher-meta">ID {{ row.Id }}</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="所属部门" min-width="170" align="center" header-align="center">
          <template slot-scope="{ row }">
            <div class="teacher-dept">
              <div
                class="teacher-dept-name"
                :class="{ 'is-unsynced': row.DepartmentName === '未同步内部部门' }"
              >
                <div class="dept-main-title">
                  {{ displayDeptName(row) }}
                </div>
                <div v-if="hasDifferentDefaultDept(row)" class="dept-sub-title" title="教师主属部门">
                  主: {{ row.DefaultDepartmentName || row.DepartmentName }}
                </div>
              </div>

              <!-- 参考 KqtScheduleType 规范：多部门展示美观链接按钮，点击弹窗查看。最后修改：2026-09-08 -->
              <div v-if="row.InternalDepartments && row.InternalDepartments.length > 1" class="teacher-dept-btn-wrap">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-office-building"
                  class="t-dept-link-btn"
                  @click.stop="openTeacherDeptsDialog(row)"
                >
                  共 {{ row.InternalDepartments.length }} 个部门
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="关联校区" min-width="130" align="center" header-align="center">
          <template slot-scope="{ row }">
            <div class="campus-tags-container">
              <template v-if="row.Campuses && row.Campuses.length">
                <el-tag
                  v-for="c in row.Campuses"
                  :key="c.CampusId"
                  size="mini"
                  type="primary"
                  effect="plain"
                  class="campus-tag"
                >{{ c.CampusName }}</el-tag>
              </template>
              <span v-else class="campus-empty">未关联</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="卡号 / 车牌" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div v-if="teacherCardNo(row) || teacherPlateNo(row)" class="teacher-creds">
              <div v-if="teacherCardNo(row)"><span class="cred-label">卡号</span>{{ teacherCardNo(row) }}</div>
              <div v-if="teacherPlateNo(row)"><span class="cred-label">车牌</span>{{ teacherPlateNo(row) }}</div>
            </div>
            <span v-else class="teacher-meta">-</span>
          </template>
        </el-table-column>

        <el-table-column label="职称 / 学历 / 教龄" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div class="teacher-profile">
              {{ joinProfileParts(row.TeacherTitle, row.EducationInfo, row.TeachingAge) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="录入信息" min-width="150" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div class="teacher-audit">
              <div>{{ row.CreateBy || '-' }}</div>
              <div class="teacher-meta">{{ row.CreateTime || '-' }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!--编辑界面-->
      <el-dialog title="编辑管理人员" :visible.sync="editFormVisible" v-model="editFormVisible"
        :close-on-click-modal="false" width="780px" custom-class="user-form-dialog">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" autocomplete="off">
          <el-tabs v-model="teacherEditTab" class="user-form-tabs">
            <el-tab-pane label="基本信息" name="basic">
              <div v-if="teacherEditTab === 'basic'" class="user-form-tab-pane">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="TeacherName">
                <el-input v-model="editForm.TeacherName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属学校">
                <el-input :value="schoolDisplayName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="主属部门" prop="Dids">
                <el-cascader
                  v-model="editForm.Dids"
                  :options="deptFormOptions"
                  :props="$deptCascaderProps || getDeptCascaderProps()"
                  filterable
                  clearable
                  placeholder="请选择内部通讯录主属部门"
                  style="width: 100%"
                />
                <p v-if="editForm.DepartmentName === '未同步内部部门'" class="dept-hint">
                  当前教师尚未挂内部部门，可在此选择后提交；也可先到「内部通讯录」同步教师。
                </p>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 所属全部内部部门全景看板。创建于 2026-09-08 -->
          <el-row v-if="editForm.InternalDepartments && editForm.InternalDepartments.length" :gutter="20">
            <el-col :span="24">
              <el-form-item label="全部部门">
                <div class="teacher-all-depts-card">
                  <div class="all-depts-tags">
                    <el-tag
                      v-for="dept in editForm.InternalDepartments"
                      :key="dept.DepartmentId"
                      size="small"
                      :type="isCurrentMainDept(dept) ? 'primary' : 'info'"
                      :effect="isCurrentMainDept(dept) ? 'dark' : 'plain'"
                      class="dept-all-tag"
                    >
                      <i v-if="isCurrentMainDept(dept)" class="el-icon-star-on" style="margin-right:2px;"></i>
                      {{ dept.DepartmentName }}
                      <span v-if="isCurrentMainDept(dept)" class="tag-main-badge">(主)</span>
                    </el-tag>
                  </div>
                  <div class="all-depts-tip">
                    <i class="el-icon-info"></i>
                    多部门关系由钉钉内部通讯录同步维护
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="关联校区" prop="CampusIds">
                <el-select v-model="editForm.CampusIds" multiple placeholder="请选择关联校区（可多选）" style="width: 100%">
                  <el-option
                    v-for="item in campusOptions"
                    :key="item.Id"
                    :label="formatCampusOptionLabel(item)"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="编号" prop="Number">
                <el-input v-model="editForm.Number" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职务" prop="Job">
                <el-input v-model="editForm.Job" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="教师职称" prop="TeacherTitle">
                <el-select v-model="editForm.TeacherTitle" placeholder="请选择职称" style="width: 100%" clearable>
                  <el-option label="正高级教师" value="正高级教师"></el-option>
                  <el-option label="副高级教师" value="副高级教师"></el-option>
                  <el-option label="一级教师" value="一级教师"></el-option>
                  <el-option label="二级教师" value="二级教师"></el-option>
                  <el-option label="三级教师" value="三级教师"></el-option>
                  <el-option label="特级教师" value="特级教师"></el-option>
                  <el-option label="高级教师" value="高级教师"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最高学历" prop="EducationInfo">
                <el-select v-model="editForm.EducationInfo" placeholder="请选择学历" style="width: 100%" clearable>
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="研究生" value="研究生"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                  <el-option label="研究生以上" value="研究生以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="教龄" prop="TeachingAge">
                <el-select v-model="editForm.TeachingAge" placeholder="请选择教龄" style="width: 100%" clearable>
                  <el-option label="1年" value="1年"></el-option>
                  <el-option label="2年" value="2年"></el-option>
                  <el-option label="3年" value="3年"></el-option>
                  <el-option label="4年" value="4年"></el-option>
                  <el-option label="5年" value="5年"></el-option>
                  <el-option label="6年" value="6年"></el-option>
                  <el-option label="7年" value="7年"></el-option>
                  <el-option label="8年" value="8年"></el-option>
                  <el-option label="9年" value="9年"></el-option>
                  <el-option label="10年及以上" value="10年及以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生日">
                <el-date-picker type="date" placeholder="选择日期" v-model="editForm.Birthday"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯" prop="HomeTown">
                <el-input v-model="editForm.HomeTown" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别">
                <el-radio-group v-model="editForm.Sex" v-removeAriaHidden>
                  <el-radio class="radio" :label="1">男</el-radio>
                  <el-radio class="radio" :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民族" prop="TeacherNational">
                <el-input v-model="editForm.TeacherNational" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="身份证号" prop="IdCard">
                <el-input v-model="editForm.IdCard" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="头像">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-change="handleAvatarChange">
                  <div v-if="imageUrl" class="avatar-wrapper">
                    <img v-oss-src="imageUrl" class="avatar" />
                    <div class="avatar-mask">
                      <i class="el-icon-delete" @click.stop="handleRemoveAvatar"></i>
                    </div>
                  </div>
                  <i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
                  <i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
                  <div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
                  </div>
                </el-upload>
                <div v-if="imageSizeKb > 0" class="avatar-size-tip" :class="{ 'is-over': imageSizeKb > 500 }">
                  图片大小：{{ imageSizeKb }} KB
                </div>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号与扩展" name="account">
              <div v-if="teacherEditTab === 'account'" class="user-form-tab-pane">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="卡号" prop="CardNumber">
                <el-input v-model="editForm.CardNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IMEI" prop="Imei">
                <el-input v-model="editForm.Imei" auto-complete="off" :readonly="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="第三方ID" prop="ThirdPartyCode">
                <el-input v-model="editForm.ThirdPartyCode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="血型" prop="BloodType">
                <el-select v-model="editForm.BloodType" placeholder="请选择血型">
                  <el-option label="未知" value=""></el-option>
                  <el-option label="A型" value="A"></el-option>
                  <el-option label="B型" value="B"></el-option>
                  <el-option label="O型" value="0"></el-option>
                  <el-option label="AB型" value="AB"></el-option>
                  <el-option label="RH型" value="RH"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="人员账号" prop="Account">
                <el-input v-model="editForm.Account" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登录密码" prop="Pwaaword">
                <password-input v-model="editForm.Pwaaword"></password-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="ContactPerson">
                <el-input v-model="editForm.ContactPerson" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactPhone">
                <el-input v-model="editForm.ContactPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="车牌">
                <div
                  ref="editVehicleList"
                  class="vehicle-list"
                  :class="{ 'is-scrollable': (editForm.vehicleList || []).length > 3 }"
                >
                  <div v-for="(v, vIdx) in editForm.vehicleList" :key="'edit_vh_' + vIdx" class="vehicle-row">
                    <plate-no-input v-model="v.plateNo" style="flex:1;"></plate-no-input>
                    <el-input v-model="v.vehicleType" placeholder="车型(可选)" style="flex:1;"></el-input>
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                      v-if="editForm.vehicleList.length > 1"
                      @click="removeEditTeacherVehicleRow(vIdx)"></el-button>
                  </div>
                </div>
                <div class="vehicle-list-actions">
                  <el-button type="text" icon="el-icon-plus" @click="addEditTeacherVehicleRow">添加车牌</el-button>
                  <span class="vehicle-list-count">共 {{ (editForm.vehicleList || []).length }} 个</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地址">
                <el-input type="textarea" v-model="editForm.Address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--新增界面-->
      <el-dialog title="新增管理人员" :visible.sync="addFormVisible" v-model="addFormVisible"
        :close-on-click-modal="false" width="780px" custom-class="user-form-dialog">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" class="demo-form-inline" autocomplete="off">
          <el-tabs v-model="teacherAddTab" class="user-form-tabs">
            <el-tab-pane label="基本信息" name="basic">
              <div v-if="teacherAddTab === 'basic'" class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="TeacherName">
                <el-input v-model="addForm.TeacherName" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="所属学校">
                <el-input :value="schoolDisplayName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="所属部门" prop="Dids">
                <el-cascader
                  v-model="addForm.Dids"
                  :options="deptFormOptions"
                  :props="$deptCascaderProps || getDeptCascaderProps()"
                  filterable
                  clearable
                  placeholder="请选择内部通讯录部门"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="关联校区" prop="CampusIds">
                <el-select v-model="addForm.CampusIds" multiple placeholder="请选择关联校区（可多选）" style="width: 100%">
                  <el-option
                    v-for="item in campusOptions"
                    :key="item.Id"
                    :label="formatCampusOptionLabel(item)"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="编号" prop="Number">
                <el-input v-model="addForm.Number" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职务" prop="Job">
                <el-input v-model="addForm.Job" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="教师职称" prop="TeacherTitle">
                <el-select v-model="addForm.TeacherTitle" placeholder="请选择职称" style="width: 100%" clearable>
                  <el-option label="正高级教师" value="正高级教师"></el-option>
                  <el-option label="副高级教师" value="副高级教师"></el-option>
                  <el-option label="一级教师" value="一级教师"></el-option>
                  <el-option label="二级教师" value="二级教师"></el-option>
                  <el-option label="三级教师" value="三级教师"></el-option>
                  <el-option label="特级教师" value="特级教师"></el-option>
                  <el-option label="高级教师" value="高级教师"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最高学历" prop="EducationInfo">
                <el-select v-model="addForm.EducationInfo" placeholder="请选择学历" style="width: 100%" clearable>
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="研究生" value="研究生"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                  <el-option label="研究生以上" value="研究生以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="教龄" prop="TeachingAge">
                <el-select v-model="addForm.TeachingAge" placeholder="请选择教龄" style="width: 100%" clearable>
                  <el-option label="1年" value="1年"></el-option>
                  <el-option label="2年" value="2年"></el-option>
                  <el-option label="3年" value="3年"></el-option>
                  <el-option label="4年" value="4年"></el-option>
                  <el-option label="5年" value="5年"></el-option>
                  <el-option label="6年" value="6年"></el-option>
                  <el-option label="7年" value="7年"></el-option>
                  <el-option label="8年" value="8年"></el-option>
                  <el-option label="9年" value="9年"></el-option>
                  <el-option label="10年及以上" value="10年及以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="生日">
                <el-date-picker type="date" placeholder="选择日期" v-model="addForm.Birthday"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="籍贯" prop="HomeTown">
                <el-input v-model="addForm.HomeTown" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="性别">
                <el-radio-group v-model="addForm.Sex" v-removeAriaHidden>
                  <el-radio class="radio" :label="1">男</el-radio>
                  <el-radio class="radio" :label="0">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="民族" prop="TeacherNational">
                <el-input v-model="addForm.TeacherNational" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="身份证号" prop="IdCard">
                <el-input v-model="addForm.IdCard" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="头像">
                <el-upload class="avatar-uploader" action="#" :auto-upload="false" accept="image/jpeg,image/jpg,image/png"
                  :show-file-list="false" :on-change="handleAvatarChange">
                  <div v-if="imageUrl" class="avatar-wrapper">
                    <img v-oss-src="imageUrl" class="avatar" />
                    <div class="avatar-mask">
                      <i class="el-icon-delete" @click.stop="handleRemoveAvatar"></i>
                    </div>
                  </div>
                  <i v-if="!imageUrl && !imageLoadding" class="el-icon-plus avatar-uploader-icon"></i>
                  <i v-if="!imageUrl && imageLoadding" class="el-icon-loading avatar-uploader-icon"></i>
                  <div class="avatar-uploader-tip" v-if="!imageUrl && !imageLoadding">
                  </div>
                </el-upload>
                <div v-if="imageSizeKb > 0" class="avatar-size-tip" :class="{ 'is-over': imageSizeKb > 500 }">
                  图片大小：{{ imageSizeKb }} KB
                </div>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
            <el-tab-pane label="账号与扩展" name="account">
              <div v-if="teacherAddTab === 'account'" class="user-form-tab-pane">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="卡号" prop="CardNumber">
                <el-input v-model="addForm.CardNumber" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="IMEI" prop="Imei">
                <el-input v-model="addForm.Imei" auto-complete="off" :readonly="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="血型" prop="BloodType">
                <el-select v-model="addForm.BloodType" placeholder="请选择血型">
                  <el-option label="未知" value=""></el-option>
                  <el-option label="A型" value="A"></el-option>
                  <el-option label="B型" value="B"></el-option>
                  <el-option label="O型" value="0"></el-option>
                  <el-option label="AB型" value="AB"></el-option>
                  <el-option label="RH型" value="RH"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="人员账号" prop="Account">
                <el-input v-model="addForm.Account" auto-complete="off" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="登录密码" prop="Pwaaword">
                <password-input :key="'teacher-add-pwd-' + addPwdInputKey" v-model="addForm.Pwaaword"></password-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人" prop="ContactPerson">
                <el-input v-model="addForm.ContactPerson" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="ContactPhone">
                <el-input v-model="addForm.ContactPhone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="车牌">
                <div
                  ref="addVehicleList"
                  class="vehicle-list"
                  :class="{ 'is-scrollable': (addForm.vehicleList || []).length > 3 }"
                >
                  <div v-for="(v, vIdx) in addForm.vehicleList" :key="'add_vh_' + vIdx" class="vehicle-row">
                    <plate-no-input v-model="v.plateNo" style="flex:1;"></plate-no-input>
                    <el-input v-model="v.vehicleType" placeholder="车型(可选)" style="flex:1;"></el-input>
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                      v-if="addForm.vehicleList.length > 1"
                      @click="removeAddTeacherVehicleRow(vIdx)"></el-button>
                  </div>
                </div>
                <div class="vehicle-list-actions">
                  <el-button type="text" icon="el-icon-plus" @click="addAddTeacherVehicleRow">添加车牌</el-button>
                  <span class="vehicle-list-count">共 {{ (addForm.vehicleList || []).length }} 个</span>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="地址">
                <el-input type="textarea" v-model="addForm.Address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="同步钉钉教师" :visible.sync="syncTypeDialogVisible" width="680px"
        custom-class="teacher-sync-dialog" :close-on-click-modal="false">
        <div class="teacher-sync-target">
          <span><i class="el-icon-s-custom"></i> 选择同步内容</span>
          <strong>教师</strong>
          <el-tag size="mini" type="primary" effect="plain">内部通讯录</el-tag>
        </div>

        <section class="teacher-sync-scope-tree">
          <header>
            <div>
              <strong>选择同步范围</strong>
              <span>勾选本地内部部门；同步钉钉企业内部通讯录成员（非家校任教）</span>
            </div>
          </header>
          <div class="teacher-sync-scope-tree__body">
            <el-tree
              v-if="syncScopeTreeNodes.length"
              ref="syncScopeTree"
              :key="'sync-scope-' + syncScopeTreeKey"
              :data="syncScopeTreeNodes"
              :props="{ label: 'label', children: 'children' }"
              node-key="value"
              show-checkbox
              check-on-click-node
              :expand-on-click-node="false"
              :default-expanded-keys="syncScopeTreeExpandedKeys"
              class="custom-ding-tree"
            />
            <div v-else class="teacher-sync-tree__empty">
              <i class="el-icon-receiving"></i>
              <span>暂无可选的内部组织节点</span>
            </div>
          </div>
        </section>

        <div class="teacher-sync-notice">
          <i class="el-icon-info"></i>
          <p>钉钉/微信教师端登录须先在教学架构完成家校任教同步。</p>
        </div>

        <div slot="footer" class="teacher-sync-footer">
          <span class="teacher-sync-footer__hint">
            <i class="el-icon-info"></i>
            提交后可在钉钉同步中心查看进度
          </span>
          <div class="teacher-sync-footer__actions">
            <el-button type="text" icon="el-icon-s-operation" @click="openTaskCenterFromSync">打开同步中心</el-button>
            <el-button @click="syncTypeDialogVisible = false">取消</el-button>
            <el-button type="primary" icon="el-icon-upload2" :loading="!!syncLoading" @click="handleSyncTeacher">提交任务</el-button>
          </div>
        </div>
      </el-dialog>

      <ding-talk-sync-task-center-dialog
        :visible.sync="taskCenterVisible"
        :school-department-id="resolveSchoolId()"
        :school-name="schoolDisplayName"
        :big-type="0"
      />

      <!-- 导入教师主表：选择文件 -->
      <el-dialog :visible.sync="teacherImportDialogVisible" width="860px" custom-class="person-import-dialog"
        :close-on-click-modal="false" append-to-body @closed="onTeacherImportDialogClosed">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-s-custom"></i></span>
          <div>
            <strong>批量导入教师主表</strong>
            <p>下载模板填写后上传，核对无误再确认写入</p>
          </div>
        </div>
        <div class="pi-body">
          <div class="pi-steps">
            <div class="pi-step">
              <span class="pi-step__no">1</span>
              <div><strong>下载模板</strong><em>按列填写教师信息</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">2</span>
              <div><strong>上传 Excel</strong><em>支持 .xlsx / .xls</em></div>
            </div>
            <i class="el-icon-arrow-right pi-step__arrow"></i>
            <div class="pi-step">
              <span class="pi-step__no">3</span>
              <div><strong>核对导入</strong><em>预览后再确认写入</em></div>
            </div>
          </div>
          <button type="button" class="pi-template-card" @click="downloadTeacherImportTemplate">
            <span class="pi-template-card__icon"><i class="el-icon-document"></i></span>
            <span class="pi-template-card__meta">
              <strong>教师主表批量导入模板.xlsx</strong>
              <em>含教师ID、姓名、卡号、职务、部门、性别、头像、第三方ID、关联校区</em>
            </span>
            <span class="pi-template-card__action"><i class="el-icon-download"></i>下载模板</span>
          </button>
          <el-upload :key="'teacher-upload-' + teacherImportUploadKey" ref="teacherImportUpload"
            class="pi-upload" drag action="#" :auto-upload="false" :limit="1" :show-file-list="false"
            accept=".xlsx,.xls" :on-change="onTeacherImportFileChange" :on-remove="onTeacherImportFileRemove"
            :on-exceed="onTeacherImportExceed">
            <div v-if="teacherImportFileRaw" class="pi-upload__file">
              <i class="el-icon-success pi-upload__ok"></i>
              <div>
                <strong>{{ teacherImportFileRaw.name }}</strong>
                <em>已选择，点击「解析并预览」进入核对</em>
              </div>
            </div>
            <div v-else class="pi-upload__empty">
              <i class="el-icon-upload2"></i>
              <strong>点击选择或拖拽 Excel 到此处</strong>
              <em>仅支持标准 .xlsx / .xls 文件</em>
            </div>
          </el-upload>
        </div>
        <div slot="footer" class="pi-footer">
          <el-button @click="teacherImportDialogVisible = false">关闭</el-button>
          <el-button type="primary" icon="el-icon-view" :disabled="!teacherImportFileRaw"
            :loading="teacherImportParsing" @click="parseTeacherImportFile">
            解析并预览
          </el-button>
        </div>
      </el-dialog>

      <!-- 教师主表导入核对 -->
      <el-dialog :visible.sync="excelShow" :close-on-click-modal="false" width="78%"
        custom-class="person-import-dialog" append-to-body
        :before-close="(done) => { this.backToTeacherImportSelect(); done(); }">
        <div slot="title" class="pi-dialog-title">
          <span class="pi-dialog-title__icon"><i class="el-icon-document-checked"></i></span>
          <div>
            <strong>教师主表导入核对</strong>
            <p>共 {{ outputs.length }} 条，确认无误后写入系统</p>
          </div>
        </div>
        <el-table :data="outputs" ref="outputs_table" class="pi-preview-table" border stripe
          style="width: 100%" max-height="520">
          <el-table-column prop="TeacherId" label="教师ID" width="100" show-overflow-tooltip />
          <el-table-column prop="TeacherName" label="姓名" width="90" show-overflow-tooltip />
          <el-table-column prop="CardNumber" label="卡号" width="110" show-overflow-tooltip />
          <el-table-column prop="Job" label="职务" width="100" show-overflow-tooltip />
          <el-table-column prop="DepartmentName" label="部门" min-width="120" show-overflow-tooltip />
          <el-table-column prop="Sex" label="性别" width="60" />
          <el-table-column prop="HeadPhotoImage" label="头像" min-width="120" show-overflow-tooltip />
          <el-table-column prop="ThirdPartyCode" label="第三方ID" width="120" show-overflow-tooltip />
          <el-table-column prop="CampusNames" label="关联校区" min-width="120" show-overflow-tooltip />
          <el-table-column fixed="right" label="操作" align="center" width="90">
            <template slot-scope="scope">
              <el-button type="text" class="pi-row-del" @click="removeImport(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="pi-footer">
          <el-button @click="backToTeacherImportSelect">返回上一步</el-button>
          <el-button type="primary" icon="el-icon-upload2" :disabled="!outputs.length" @click="SavaImport">
            确认导入
          </el-button>
        </div>
      </el-dialog>

      <import-result-dialog
        :visible.sync="importResultVisible"
        :result="importResult"
      />

      <!-- 重复教师检测弹窗 -->
      <el-dialog title="重复教师检测" :visible.sync="duplicateDialogVisible" width="75%" :close-on-click-modal="false" append-to-body>
        <div class="duplicate-tip">以下为可能重复教师，仅供人工核对；系统不强制拦截删除。</div>
        <div class="duplicate-summary">
          <el-tag type="info" size="small">重复组数：{{ duplicateSummary.groupCount }}</el-tag>
          <el-tag type="info" size="small">涉及教师：{{ duplicateSummary.teacherCount }}</el-tag>
        </div>
        <el-empty v-if="!duplicateLoading && duplicateGroups.length === 0" description="未发现重复教师"></el-empty>
        <el-collapse v-model="duplicateActiveGroups" v-loading="duplicateLoading" class="duplicate-collapse">
          <el-collapse-item v-for="group in duplicateGroups" :key="group.GroupKey" :name="group.GroupKey">
            <template slot="title">
              <span class="duplicate-group-title">
                {{ group.Items[0] ? group.Items[0].TeacherName : "-" }}（ThirdPartyCode: {{ group.Items[0] ? (group.Items[0].ThirdPartyCode || "-") : "-" }}）
              </span>
              <el-tag size="mini" type="warning">重复 {{ group.DuplicateCount }} 条</el-tag>
            </template>
            <el-table :data="group.Items" border size="mini" style="width: 100%">
              <el-table-column prop="TeacherId" label="教师ID" width="90"></el-table-column>
              <el-table-column prop="TeacherName" label="姓名" width="110"></el-table-column>
              <el-table-column prop="DepartmentName" label="部门" min-width="120"></el-table-column>
              <el-table-column label="风险标识" min-width="190">
                <template slot-scope="scope">
                  <el-tag v-for="(tag, index) in scope.row.RiskTags" :key="index" size="mini" :type="riskTagType(tag)"
                    style="margin-right: 4px; margin-bottom: 3px;">{{ tag }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="TeachingClassNames" label="任教班级" min-width="180">
                <template slot-scope="scope">
                  <span>{{ scope.row.TeachingClassNames || "-" }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="ConsumptionCount" label="消费次数" width="90"></el-table-column>
              <el-table-column prop="UserBalance" label="余额" width="110">
                <template slot-scope="scope">
                  <span :style="{ color: scope.row.UserBalance > 0 ? '#F56C6C' : '#67C23A' }">{{ formatBalance(scope.row.UserBalance) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" style="color: #F56C6C;" @click="removeDuplicateTeacher(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
        <span slot="footer" class="dialog-footer">
          <el-button @click="duplicateDialogVisible = false">关 闭</el-button>
          <el-button type="primary" :loading="duplicateLoading" @click="duplicateTeacherCheck">刷 新</el-button>
        </span>
      </el-dialog>

      <LocalAvatarMigrateDialog
        :visible.sync="localAvatarMigrateVisible"
        person-type="teacher"
        :school-department-id="ossSchoolDepartmentId"
        @done="onLocalAvatarMigrateDone">
      </LocalAvatarMigrateDialog>
      
      <HeadPhotoCompressDialog
        :visible.sync="headPhotoCompressVisible"
        person-type="teacher"
        :school-department-id="ossSchoolDepartmentId"
        @done="onHeadPhotoCompressDone">
      </HeadPhotoCompressDialog>

      <!-- 教师所属内部部门查看弹窗。参考 KqtScheduleType 风格规范设计。最后更新：2026-09-08 -->
      <el-dialog
        :title="viewTeacherDeptDialog.title"
        :visible.sync="viewTeacherDeptDialog.visible"
        width="660px"
        :close-on-click-modal="false"
        append-to-body
        custom-class="t-dept-view-dialog"
      >
        <div class="t-view-head">
          <div class="t-view-head-item">
            <span class="label">教师：</span>
            <span class="val">{{ viewTeacherDeptDialog.teacherName }}</span>
          </div>
          <div class="t-view-head-item">
            <span class="label">主属部门：</span>
            <span class="val main-dept-badge">
              <i class="el-icon-star-on"></i>
              {{ viewTeacherDeptDialog.defaultDeptName }}
            </span>
          </div>
          <div
            v-if="viewTeacherDeptDialog.contextDeptName && viewTeacherDeptDialog.contextDeptName !== viewTeacherDeptDialog.defaultDeptName && viewTeacherDeptDialog.contextDeptName !== '-'"
            class="t-view-head-item"
          >
            <span class="label">当前匹配：</span>
            <span class="val match-dept-badge">{{ viewTeacherDeptDialog.contextDeptName }}</span>
          </div>
          <div class="t-view-head-item">
            <span class="label">总数：</span>
            <span class="val count-badge">{{ viewTeacherDeptDialog.depts ? viewTeacherDeptDialog.depts.length : 0 }} 个内部部门</span>
          </div>
        </div>

        <div class="t-view-toolbar">
          <el-input
            v-model="viewTeacherDeptDialog.filterKey"
            size="small"
            placeholder="搜索部门名称..."
            prefix-icon="el-icon-search"
            clearable
            class="t-view-search-input"
          />
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-document-copy"
            @click="copyAllTeacherDeptNames"
          >
            复制全部部门
          </el-button>
        </div>

        <div class="t-view-table-wrap">
          <el-table
            :data="filteredTeacherDepts"
            size="small"
            max-height="340"
            border
            stripe
            class="t-view-table"
          >
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="DepartmentName" label="内部部门名称" min-width="220">
              <template slot-scope="scope">
                <span class="dept-name-text">{{ scope.row.DepartmentName }}</span>
              </template>
            </el-table-column>
            <el-table-column label="性质" width="110" align="center">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.IsDefault"
                  size="small"
                  type="primary"
                  effect="dark"
                  class="dept-role-tag"
                >
                  <i class="el-icon-star-on"></i> 主属部门
                </el-tag>
                <el-tag
                  v-else
                  size="small"
                  type="info"
                  effect="plain"
                  class="dept-role-tag"
                >
                  兼任部门
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="SyncSource" label="来源" width="100" align="center">
              <template slot-scope="scope">
                <span class="dept-source-text">
                  {{ scope.row.SyncSource === 'DingDing' ? '钉钉同步' : (scope.row.SyncSource || '手动') }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  icon="el-icon-document-copy"
                  @click="copySingleTeacherDeptName(scope.row.DepartmentName)"
                >
                  复制
                </el-button>
              </template>
            </el-table-column>
            <div slot="empty" class="t-view-empty">暂无匹配的部门</div>
          </el-table>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="viewTeacherDeptDialog.visible = false">关 闭</el-button>
        </div>
      </el-dialog>

    </section>
  </section>

</template>

<script>
import util from "../../../util/date";
import { getTeacherMasterListPage, removeTeacherMaster, batchDeleteTeacherMaster, editTeacherMaster, addTeacherMaster, exportTeacherMaster, importTeacherMasterBatch, getDuplicateTeacherWarnings, saveTeacherVehicles, getTeacherLocalAvatarMigrateStatus } from '../../api/modules/personnel';
import { getInternalDepartmentTree, getStudentLiveTypeList, submitDingTalkSyncTask, getDepartmentById, getDepartmentType, syncAllSubDeptTeacherToTb } from '../../api/modules/department';
import { getDeptCascaderProps, prepareInternalDeptCascaderTree, deptIdsEqual, normalizeDeptId } from '../../utils/deptCascaderProps';
import { buildSyncScopeConfirmMessage } from '../../utils/dingTalkSyncScope';
import DingTalkSyncTaskCenterDialog from '../../components/DingTalkSyncTaskCenterDialog';
import { BaseApiUrl } from '../../api/base';
import { getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import PlateNoInput from '@/components/PlateNoInput'
import PasswordInput, { DEFAULT_LOGIN_PASSWORD } from '../../components/PasswordInput'
import LocalAvatarMigrateDialog from '../../components/LocalAvatarMigrateDialog'
import HeadPhotoCompressDialog from '../../components/HeadPhotoCompressDialog'
import ImportResultDialog from '../../components/ImportResultDialog'
import { attachLocalAvatarFile, revokeLocalAvatarPreview, uploadHeadPic, stripOssPresignParams } from '../../utils/ossMediaUpload'
// excel 读取
import { read, utils, writeFile } from "xlsx";
import "../../style/person-import-dialog.css";

export default {
  components: { Toolbar, DepartmentPane, PlateNoInput, PasswordInput, LocalAvatarMigrateDialog, HeadPhotoCompressDialog, ImportResultDialog, DingTalkSyncTaskCenterDialog },
  data() {
    return {
      filters: {
      },
      campusOptions: [],
      searchList: [
        {
          label: '姓名',
          key: 'teacherName',
        },
        {
          label: '关联校区',
          key: 'campusId',
          type: 'select',
          clearable: true,
          options: [], // 将在运行时通过 campusOptions 同步
        },
      ],
      BaseApiUrl: BaseApiUrl, //网络前缀
      users: [],
      roles: [],
      deptFormOptions: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      multipleSelection: [], //列表多选行
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      teacherEditTab: 'basic',
      teacherAddTab: 'basic',
      editFormRules: {
        TeacherName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        Pwaaword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        Dids: [{ required: true, message: "请选择所属部门", trigger: "change" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        TeacherName: "",
        Birthday: "",
        TeacherNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        IdCard: "",
        WorkNumber: "",
        Number: "",
        Job: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Pwaaword: "",
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        HeadPhotoImage: '',
        TeacherTitle: "",
        EducationInfo: "",
        TeachingAge: "",
        ThirdPartyCode: "",
        CampusIds: [],
        vehicleList: [{ plateNo: "", vehicleType: "" }],
      },
      addFormVisible: false, //新增界面是否显示
      addPwdInputKey: 0,
      addLoading: false,
      addFormRules: {
        TeacherName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        Pwaaword: [{ required: true, message: "请输入密码", trigger: "blur" }],
        Dids: [{ required: true, message: "请选择所属部门", trigger: "change" }],
      },
      //新增界面数据
      addForm: {
        TeacherName: "",
        Birthday: "",
        TeacherNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        IdCard: "",
        WorkNumber: "",
        Number: "",
        Job: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Pwaaword: DEFAULT_LOGIN_PASSWORD,
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        HeadPhotoImage: '',
        TeacherTitle: "",
        EducationInfo: "",
        TeachingAge: "",
        ThirdPartyCode: "",
        CampusIds: [],
        vehicleList: [{ plateNo: "", vehicleType: "" }],
      },
      DepartmentId: 0,
      SchoolId: 0, // 新增：保存当前部门所属学校的ID
      imageUrl: '',
      pendingAvatarFile: null,
      savedHeadPhotoImage: '',
      imageLoadding: false,
      imageSizeKb: 0,
      currentDepartment: null,
      /** 当前顶部学校的机构类型，用于控制钉钉同步按钮。最后更新：2026-08-30 */
      currentSchoolSchType: '',
      syncTypeDialogVisible: false,
      syncLoading: '',
      syncScopeTreeKey: 0,
      syncScopeTreeNodes: [],
      syncScopeTreeExpandedKeys: [],
      taskCenterVisible: false,
      outputs: [], // 导入展示
      excelShow: false, // 导入展示弹框
      teacherImportDialogVisible: false,
      teacherImportFileRaw: null,
      teacherImportParsing: false,
      teacherImportUploadKey: 0,
      teacherImportKeepFileOnClose: false,
      importResultVisible: false,
      importResult: null,
      duplicateDialogVisible: false,
      localAvatarMigrateVisible: false,
      headPhotoCompressVisible: false,
      ossAvatarEnabled: false,
      duplicateLoading: false,
      duplicateGroups: [],
      duplicateActiveGroups: [],
      duplicateSummary: {
        groupCount: 0,
        teacherCount: 0
      },
      // 教师所属内部部门查看弹窗状态。参考 KqtScheduleType 设计。创建于 2026-09-08
      viewTeacherDeptDialog: {
        visible: false,
        title: '查看内部部门',
        teacherName: '',
        defaultDeptName: '',
        contextDeptName: '',
        filterKey: '',
        depts: [],
      },
    };
  },
  computed: {
    /** 教师内部部门查看弹窗的过滤列表。创建于 2026-09-08 */
    filteredTeacherDepts() {
      const list = (this.viewTeacherDeptDialog && this.viewTeacherDeptDialog.depts) || [];
      const key = (this.viewTeacherDeptDialog && this.viewTeacherDeptDialog.filterKey || '').trim().toLowerCase();
      if (!key) return list;
      return list.filter(item => {
        const name = String(item.DepartmentName || '').toLowerCase();
        const role = item.IsDefault ? '主属部门 主' : '兼任部门 兼任';
        const src = String(item.SyncSource || '').toLowerCase();
        return name.includes(key) || role.includes(key) || src.includes(key);
      });
    },
    /** 顶栏当前学校名称；表单「所属学校」只读展示用 */
    schoolDisplayName() {
      return this.$store.state.activeSchoolName
        || window.localStorage.getItem('activeSchoolName')
        || (this.currentDepartment && this.currentDepartment.label)
        || '';
    },
    /** OSS 子组件使用当前学校，兼容 Vuex 尚未恢复时的本地缓存。 */
    ossSchoolDepartmentId() {
      return this.resolveSchoolId();
    },
    /** 仅钉钉学校显示同步钉钉入口。最后更新：2026-08-30 */
    isDingTalkSchool() {
      return String(this.currentSchoolSchType || '').toLowerCase() === 'dingding'
    },
  },
  methods: {
    getDeptCascaderProps,
    /** 是否为「同步钉钉*」入口（不匹配头像迁移等其它按钮）。最后更新：2026-08-30 */
    isDingTalkSyncToolbarButton(btn) {
      if (!btn) return false
      const name = String(btn.name || '')
      const func = String(btn.Func || '').toLowerCase()
      if (/钉钉/.test(name)) return true
      return func === 'syncteacher'
    },
    /** 按学校类型隐藏「同步钉钉教师」按钮（不影响头像迁移 OSS） */
    refreshDingTalkSyncButtonVisibility() {
      const hide = !this.isDingTalkSchool
      ;(this.buttonList || []).forEach(btn => {
        if (!this.isDingTalkSyncToolbarButton(btn)) return
        const func = String(btn.Func || '').toLowerCase()
        if (/migrate|compress|qrcode/.test(func)) return
        this.$set(btn, 'IsHide', hide)
      })
      this.updateMigrateButtonVisibility()
    },
    /** 加载当前顶部学校的 SchType。最后更新：2026-08-30 */
    async loadCurrentSchoolSchType() {
      const schoolId = this.resolveSchoolId()
      if (!schoolId) {
        this.currentSchoolSchType = ''
        this.refreshDingTalkSyncButtonVisibility()
        return
      }
      try {
        const res = await getDepartmentById(schoolId)
        const dept = (res.data && res.data.response) || {}
        this.currentSchoolSchType = dept.SchType || dept.schType || ''
      } catch (e) {
        this.currentSchoolSchType = ''
      }
      this.refreshDingTalkSyncButtonVisibility()
    },
    /** 获取顶部选择的学校 ID，保留 long 字符串精度。 */
    resolveSchoolId() {
      const candidates = [
        this.$store.state.activeSchoolId,
        window.localStorage.getItem('activeSchoolId'),
        this.SchoolId,
      ];
      return candidates.find(id => /^\d+$/.test(String(id || '')) && String(id) !== '0') || '';
    },
    /**
     * 加载编辑/新增表单用的内部通讯录树（不含校区等家校节点）。按学校缓存，避免每次打开弹窗重建级联。最后更新：2026-08-30
     */
    loadDeptFormTree() {
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        this.deptFormOptions = [];
        this._deptFormTreeSchoolId = '';
        return;
      }
      if (String(this._deptFormTreeSchoolId) === String(schoolId) && this.deptFormOptions && this.deptFormOptions.length) {
        return;
      }
      getInternalDepartmentTree({ pid: 0, scopeDepartmentId: schoolId }).then((res) => {
        if (String(this.resolveSchoolId()) !== String(schoolId)) return;
        const root = res.data && res.data.response;
        if (root && root.children) {
          this.deptFormOptions = prepareInternalDeptCascaderTree(root.children, { clearAllDisabled: true });
        } else {
          this.deptFormOptions = prepareInternalDeptCascaderTree(root ? [root] : [], { clearAllDisabled: true });
        }
        this._deptFormTreeSchoolId = schoolId;
      }).catch(() => {
        this.deptFormOptions = [];
        this._deptFormTreeSchoolId = '';
      });
    },
    /** 校验失败时切换到含错误字段的 Tab。最后更新：2026-06-28 */
    focusFormTabOnValidateFail(formRef, tabField, accountFieldProps) {
      this.$nextTick(() => {
        const form = this.$refs[formRef];
        if (!form || !form.fields) return;
        const accountSet = new Set(accountFieldProps || []);
        for (let i = 0; i < form.fields.length; i++) {
          const field = form.fields[i];
          if (field.validateState !== 'error') continue;
          const prop = field.prop;
          const isAccount = accountSet.has(prop);
          this[tabField] = isAccount ? 'account' : 'basic';
          break;
        }
      });
    },
    teacherAccountFieldProps() {
      return ['CardNumber', 'Imei', 'ThirdPartyCode', 'BloodType', 'Account', 'Pwaaword', 'ContactPerson', 'ContactPhone'];
    },
    // 递归寻找当前学校 ID 的部门树节点
    findSchoolNode(node, schoolId) {
      if (!node) return null;
      if (deptIdsEqual(node.value, schoolId)) {
        return node;
      }
      if (node.children && node.children.length) {
        for (let i = 0; i < node.children.length; i++) {
          const found = this.findSchoolNode(node.children[i], schoolId);
          if (found) return found;
        }
      }
      return null;
    },
    revokePendingAvatarLocal() {
      revokeLocalAvatarPreview(this.imageUrl);
      this.pendingAvatarFile = null;
    },
    resetAvatarState() {
      this.revokePendingAvatarLocal();
      this.imageUrl = '';
      this.imageSizeKb = 0;
      this.savedHeadPhotoImage = '';
    },
    handleAvatarChange(file) {
      if (!file || !file.raw) return;
      const raw = file.raw;
      const allowType = ['image/jpg', 'image/png', 'image/jpeg'];
      if (allowType.indexOf(raw.type) < 0) {
        this.$message.error('图片格式错误，请上传 jpg/png');
        return;
      }
      this.revokePendingAvatarLocal();
      const local = attachLocalAvatarFile(raw);
      this.pendingAvatarFile = local.pendingAvatarFile;
      this.imageUrl = local.pendingAvatarPreviewUrl;
      this.imageSizeKb = Number((raw.size / 1024).toFixed(1));
    },
    async ensureHeadPhotoUploaded(dids) {
      if (this.pendingAvatarFile) {
        const foo = dids && dids.length ? String(dids[dids.length - 1]) : '';
        const { url, sizeKb } = await uploadHeadPic(this.pendingAvatarFile, this, foo, 'AvatarTeacher');
        if (sizeKb && !Number.isNaN(Number(sizeKb)) && Number(sizeKb) > 0) {
          this.imageSizeKb = Number(Number(sizeKb).toFixed(1));
        }
        this.revokePendingAvatarLocal();
        this.imageUrl = url;
        this.savedHeadPhotoImage = url;
        return url;
      }
      if (!this.imageUrl) return '';
      if (String(this.imageUrl).indexOf('blob:') === 0) return '';
      return stripOssPresignParams(this.savedHeadPhotoImage || this.imageUrl);
    },
    handleRemoveAvatar() {
      this.resetAvatarState();
      if (this.editForm) this.editForm.HeadPhotoImage = '';
      if (this.addForm) this.addForm.HeadPhotoImage = '';
    },
    async calcImageSizeKbByUrl(imagePath) {
      if (!imagePath) return 0;
      const imageUrl = this.$resolveImageSrc(imagePath);
      try {
        const headResp = await fetch(imageUrl, { method: "HEAD", cache: "no-store" });
        const len = Number(headResp.headers.get("content-length"));
        if (!Number.isNaN(len) && len > 0) {
          return Number((len / 1024).toFixed(1));
        }
      } catch (e) {
      }

      try {
        const getResp = await fetch(imageUrl, { cache: "no-store" });
        const blob = await getResp.blob();
        if (blob && blob.size > 0) {
          return Number((blob.size / 1024).toFixed(1));
        }
      } catch (e) {
      }

      return 0;
    },
    async fillImageSizeForEditRow(row) {
      if (!row || !row.HeadPhotoImage) {
        this.imageSizeKb = 0;
        return;
      }

      const sizeFromList = Number(
        row.HeadPhotoSizeKb || row.HeadPhotoSize || row.HeadPhotoKb || row.ImageSizeKb || 0
      );
      if (!Number.isNaN(sizeFromList) && sizeFromList > 0) {
        this.imageSizeKb = sizeFromList;
        return;
      }

      this.imageSizeKb = await this.calcImageSizeKbByUrl(row.HeadPhotoImage);
    },

    handleChange(value) {
      this.liveTypeList = [];
      this.liveTypeId = "";
      var id = "";
      if (value.length > 1) {
        id = value[value.length - 1];
      } else {
        id = value[0];
      }
      let para = {
        id: id,
      };
      getStudentLiveTypeList(para).then((res) => {
        this.liveTypeList = res.data.response;
      });

      // 校区始终按顶部学校加载，不能使用内部部门 ID。
      this.loadCampusOptions();
    },

    loadCampusOptions() {
      const schoolId = this.resolveSchoolId();
      if (schoolId) {
        getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then(res => {
          if (String(schoolId) !== String(this.resolveSchoolId())) return;
          if (res.data.success) {
            this.campusOptions = res.data.response.data || [];
            // 同步搜素栏配置
            const campusSearch = this.searchList.find(e => e.key === 'campusId');
            if (campusSearch) {
              campusSearch.options = this.campusOptions.map(e => ({
                label: this.formatCampusOptionLabel(e),
                value: e.Id
              }));
            }
            // 切校后若工具栏仍挂着他校校区，清掉残留显示
            const curCampus = this.filters && this.filters.campusId;
            const valid = curCampus != null && curCampus !== '' && this.campusOptions.some(c => String(c.Id) === String(curCampus));
            if (!valid) {
              this.filters = { ...(this.filters || {}), campusId: null };
              if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
              }
            }
          }
        });
      } else {
        this.campusOptions = [];
        const campusSearch = this.searchList.find(e => e.key === 'campusId');
        if (campusSearch) campusSearch.options = [];
      }
    },

    /** 校区与校名相同时加类型后缀，避免和下方「所属学校」混淆。创建于 2026-09-05 */
    formatCampusOptionLabel(item) {
      if (!item) return '';
      const name = item.Name || item.name || '';
      const orgType = String(item.DeptOrgType || item.deptOrgType || '').toLowerCase();
      if (orgType === 'campus') return `${name}（校区）`;
      if (orgType === 'school') return `${name}（学校）`;
      return name;
    },

    treeNodeClick(data, node, component) {
      this.currentDepartment = data;
      this.DepartmentId = data.value
      this.SchoolId = this.resolveSchoolId();
      // 切校/点树后清掉工具栏残留的他校「关联校区」
      this.filters = { ...(this.filters || {}), campusId: null };
      const campusSearch = this.searchList.find(item => item.key === 'campusId');
      if (campusSearch) campusSearch.options = [];
      if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
        this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
      }
      this.loadCampusOptions();
      this.deptFormOptions = [];
      this._deptFormTreeSchoolId = '';

      this.page = 1;
      this.handleQuery();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.currentRow = (val && val.length === 1) ? val[0] : null;
    },
    /** 行点击切换勾选，支持多选批量操作。最后更新：2026-08-30 */
    handleRowClick(row) {
      if (!this.$refs.table) return;
      this.$refs.table.toggleRowSelection(row);
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      const handler = this[item.Func];
      if (typeof handler !== 'function') {
        this.$message.error(`未实现的操作：${item.name || item.Func || '未知'}`);
        return;
      }
      handler.apply(this, item);
    },

    //性别显示转换
    formatSex: function (row, column) {
      return row.Sex == 1 ? "男" : row.Sex == 0 ? "女" : "";
    },
    /** 是否有明确性别（男/女）。最后更新：2026-08-30 */
    hasKnownSex(sex) {
      return sex == 1 || sex == 0;
    },
    sexTagType(sex) {
      if (sex == 1) return '';
      if (sex == 0) return 'danger';
      return 'info';
    },
    /** 教师卡号展示值。最后更新：2026-08-30 */
    teacherCardNo(row) {
      return String((row && (row.CardNumber || row.cardNumber)) || '').trim();
    },
    /** 教师车牌展示值。最后更新：2026-08-30 */
    teacherPlateNo(row) {
      return String((row && (row.plateSummary || row.PlateSummary)) || '').trim();
    },
    teacherNameInitial(name) {
      const text = (name || '').trim();
      return text ? text.slice(0, 1) : '师';
    },
    joinProfileParts() {
      const parts = Array.prototype.slice.call(arguments)
        .map(function (item) { return (item || '').toString().trim(); })
        .filter(Boolean);
      return parts.length ? parts.join(' · ') : '-';
    },

    /**
     * 部门主展示文案（优先当前查询命中的上下文部门）。创建于 2026-09-08
     */
    displayDeptName(row) {
      if (!row) return '-';
      return row.ContextDepartmentName || row.DepartmentName || '-';
    },

    /**
     * 当前展示部门是否与默认主部门不同（用于显示主部门补充标注）。创建于 2026-09-08
     */
    hasDifferentDefaultDept(row) {
      if (!row) return false;
      const context = row.ContextDepartmentName;
      const def = row.DefaultDepartmentName || row.DepartmentName;
      return !!(context && def && context !== def && def !== '未同步内部部门');
    },

    /**
     * 判断部门是否为编辑表单当前选中的主部门。创建于 2026-09-08
     */
    isCurrentMainDept(dept) {
      if (!dept || !this.editForm) return false;
      let currentDeptId = 0;
      if (this.editForm.Dids && this.editForm.Dids.length) {
        currentDeptId = this.editForm.Dids[this.editForm.Dids.length - 1];
      } else {
        currentDeptId = this.editForm.DepartmentId;
      }
      return String(dept.DepartmentId) === String(currentDeptId);
    },

    /**
     * 打开教师内部部门查看弹窗。参考 KqtScheduleType 风格规范。创建于 2026-09-08
     */
    openTeacherDeptsDialog(row) {
      if (!row) return;
      const depts = (row.InternalDepartments || []).slice();
      // 排序：主属部门排在首位
      depts.sort((a, b) => {
        if (a.IsDefault && !b.IsDefault) return -1;
        if (!a.IsDefault && b.IsDefault) return 1;
        return 0;
      });
      const defName = row.DefaultDepartmentName || row.DepartmentName || '-';
      const ctxName = row.ContextDepartmentName || defName;
      this.viewTeacherDeptDialog = {
        visible: true,
        title: `查看内部部门 - ${row.TeacherName || '教师'}`,
        teacherName: row.TeacherName || '-',
        defaultDeptName: defName,
        contextDeptName: ctxName,
        filterKey: '',
        depts: depts,
      };
    },

    /**
     * 复制全部内部部门名称。创建于 2026-09-08
     */
    copyAllTeacherDeptNames() {
      const depts = (this.viewTeacherDeptDialog && this.viewTeacherDeptDialog.depts) || [];
      if (!depts.length) {
        this.$message.warning('暂无部门名称可复制');
        return;
      }
      const names = depts.map(d => d.DepartmentName).filter(Boolean);
      const text = names.join('、');
      this.copyTextToClipboard(text, `已复制全部 ${names.length} 个部门名称`);
    },

    /**
     * 复制单个部门名称。创建于 2026-09-08
     */
    copySingleTeacherDeptName(name) {
      if (!name) return;
      this.copyTextToClipboard(name, `已复制：${name}`);
    },

    /**
     * 剪贴板复制通用工具。创建于 2026-09-08
     */
    copyTextToClipboard(text, successMsg) {
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success(successMsg || '复制成功');
        }).catch(() => {
          this.fallbackCopyText(text, successMsg);
        });
      } else {
        this.fallbackCopyText(text, successMsg);
      }
    },

    fallbackCopyText(text, successMsg) {
      const input = document.createElement('textarea');
      input.value = text;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success(successMsg || '复制成功');
        } else {
          this.$message.error('复制失败，请手动选择复制');
        }
      } catch (e) {
        this.$message.error('复制失败，请手动选择复制');
      } finally {
        document.body.removeChild(input);
      }
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      const querySchoolId = this.resolveSchoolId();
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        includeVehicles: true,
        ...this.filters,
      }
      this.listLoading = true;

      //NProgress.start();
      getTeacherMasterListPage(para).then(async (res) => {
        if (String(querySchoolId) !== String(this.resolveSchoolId())) {
          this.listLoading = false;
          return;
        }
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'HeadPhotoImage');
        this.users = rows;
        this.listLoading = false;
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) this.$refs.table.doLayout();
        });
        //NProgress.done();
      });
    },

    addEditTeacherVehicleRow() {
      const list = (this.editForm.vehicleList || []).slice();
      list.push({ plateNo: "", vehicleType: "" });
      this.$set(this.editForm, "vehicleList", list);
      this.$nextTick(() => this.scrollVehicleListToBottom("editVehicleList"));
    },

    removeEditTeacherVehicleRow(idx) {
      if (!this.editForm.vehicleList || this.editForm.vehicleList.length <= 1) return;
      const list = this.editForm.vehicleList.slice();
      list.splice(idx, 1);
      this.$set(this.editForm, "vehicleList", list);
    },

    addAddTeacherVehicleRow() {
      const list = (this.addForm.vehicleList || []).slice();
      list.push({ plateNo: "", vehicleType: "" });
      this.$set(this.addForm, "vehicleList", list);
      this.$nextTick(() => this.scrollVehicleListToBottom("addVehicleList"));
    },

    removeAddTeacherVehicleRow(idx) {
      if (!this.addForm.vehicleList || this.addForm.vehicleList.length <= 1) return;
      const list = this.addForm.vehicleList.slice();
      list.splice(idx, 1);
      this.$set(this.addForm, "vehicleList", list);
    },

    /** 新增车牌后滚到底，避免被滚动区挡住。最后更新：2026-08-30 */
    scrollVehicleListToBottom(refName) {
      const el = this.$refs[refName];
      const target = Array.isArray(el) ? el[0] : el;
      if (target) target.scrollTop = target.scrollHeight;
    },

    /**
     * Tab 按需渲染后，提交前补齐未挂载字段的必填校验。最后更新：2026-08-30
     */
    ensureTeacherFormRequiredForSubmit(formModel, tabField) {
      if (!(formModel.Dids && formModel.Dids.length)) {
        this[tabField] = 'basic';
        this.$message.warning('请选择所属部门');
        return false;
      }
      if (!String(formModel.TeacherName || '').trim()) {
        this[tabField] = 'basic';
        this.$message.warning('请输入姓名');
        return false;
      }
      if (!String(formModel.Pwaaword || '').trim()) {
        this[tabField] = 'account';
        this.$message.warning('请输入密码');
        return false;
      }
      return true;
    },

    buildTeacherVehiclePayload(vehicleList) {
      const list = vehicleList || [];
      return list
        .map((v) => ({
          plateNo: (v.plateNo || "").trim(),
          vehicleType: (v.vehicleType || "").trim(),
        }))
        .filter((v) => v.plateNo);
    },

    //删除
    handleDel() {
      var rows = this.multipleSelection;

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });
        return;
      }

      var row = rows[0];
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "正在校验关联业务并删除教师，请稍候…",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let para = { id: row.Id };
          removeTeacherMaster(para)
            .then((res) => {
              if (util.isEmt.format(res)) {
                return;
              }
              if (res.data.success) {
                this.$message({
                  message: res.data.msg || "删除成功",
                  type: "success",
                });
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .catch(() => {
              this.$message.error("删除失败，请稍后重试");
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(() => { });
    },

    /** 批量删除选中教师。最后更新：2026-08-30 */
    handleDelUsers() {
      if (!this.multipleSelection || this.multipleSelection.length === 0) {
        this.$message.warning("请先选择要删除的教师！");
        return;
      }
      const ids = this.multipleSelection.map(item => String(item.Id)).join(",");
      this.$confirm("确认要批量删除选中的教师吗？", "提示", { type: "warning" })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: `正在校验并批量删除 ${this.multipleSelection.length} 名教师，请稍候…`,
            background: "rgba(0, 0, 0, 0.7)",
          });
          batchDeleteTeacherMaster({ ids: ids })
            .then(res => {
              if (res.data.success) {
                this.$message.success(res.data.msg || "批量删除成功");
                this.handleQuery();
              } else {
                this.$message.error(res.data.msg || "批量删除失败");
              }
            })
            .catch(() => {
              this.$message.error("批量删除失败，请稍后重试");
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(() => { });
    },

    //显示编辑界面
    handleEdit() {
      var rows = this.multipleSelection;
      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      var row = rows[0];
      this.editFormVisible = true;
      this.teacherEditTab = 'basic';
      this.editForm = Object.assign({}, row);
      this.$set(this.editForm, 'InternalDepartments', row.InternalDepartments || []);
      if (row.Campuses) {
        this.$set(this.editForm, 'CampusIds', row.Campuses.map(c => c.CampusId));
      } else {
        this.$set(this.editForm, 'CampusIds', []);
      }

      // long 标识保持字符串，避免 Number 转换造成精度丢失；仅排除总平台节点 0。
      if (this.editForm.Dids) {
        this.editForm.Dids = this.editForm.Dids.filter(id => String(id) !== '0');
      } else {
        this.editForm.Dids = [];
      }

      this.savedHeadPhotoImage = this.editForm.HeadPhotoImage || '';
      this.pendingAvatarFile = null;
      this.imageUrl = this.editForm.HeadPhotoImage;
      this.fillImageSizeForEditRow(row);

      const vehItems = row.vehicleItems || row.VehicleItems || [];
      const vehicleList = vehItems.length
        ? vehItems.map((it) => ({
          plateNo: it.plateNo || it.PlateNo || "",
          vehicleType: it.vehicleType || it.VehicleType || "",
        }))
        : [{ plateNo: "", vehicleType: "" }];
      this.$set(this.editForm, "vehicleList", vehicleList);

      this.loadCampusOptions();
      this.loadDeptFormTree();
    },
    //显示新增界面
    handleAdd() {
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        this.$message.warning("请先选择学校");
        return;
      }
      this.addFormVisible = true;
      this.addPwdInputKey += 1;
      this.teacherAddTab = 'basic';

      this.resetAvatarState();
      var birthday = util.formatDate.format(new Date(), "yyyy-MM-dd");

      this.addForm = {
        TeacherName: "",
        Birthday: birthday,
        TeacherNational: "",
        Sex: 1,
        HomeTown: "",
        Dids: [],
        DepartmentId: 0,
        CampusIds: [],
        IdCard: "",
        WorkNumber: "",
        Number: "",
        Job: "",
        CardNumber: "",
        Imei: "",
        BloodType: "",
        LiveTypeId: "",
        Account: "",
        Pwaaword: DEFAULT_LOGIN_PASSWORD,
        ContactPerson: "",
        ContactPhone: "",
        Address: "",
        HeadPhotoImage: '',
        TeacherTitle: "",
        EducationInfo: "",
        TeachingAge: "",
        ThirdPartyCode: "",
        vehicleList: [{ plateNo: "", vehicleType: "" }],
      };

      this.loadCampusOptions();
      this.loadDeptFormTree();
    },
    //编辑
    editSubmit: function () {
      if (!this.ensureTeacherFormRequiredForSubmit(this.editForm, 'teacherEditTab')) return;
      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          this.focusFormTabOnValidateFail('editForm', 'teacherEditTab', this.teacherAccountFieldProps());
          return;
        }
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.editLoading = true;
            try {
              const dids = (this.editForm.Dids || []).slice();
              if (!dids.length) {
                this.editLoading = false;
                this.$message.warning("请选择所属部门");
                return;
              }
              const headPhotoImage = await this.ensureHeadPhotoUploaded(dids);
              this.editForm.HeadPhotoImage = headPhotoImage;

              let para = Object.assign({}, this.editForm);

              para.Birthday =
                !para.Birthday || para.Birthday == ""
                  ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                  : util.formatDate.format(new Date(para.Birthday), "yyyy-MM-dd");

              para.Dids = dids;
              para.DepartmentId = dids[dids.length - 1];
              para.LiveTypeId = this.liveTypeId;
              delete para.vehicleList;

              const closeEditAndRefresh = (msg, msgType) => {
                this.editLoading = false;
                this.$message({ message: msg, type: msgType || "success" });
                this.$refs["editForm"].resetFields();
                this.editForm.vehicleList = [{ plateNo: "", vehicleType: "" }];
                this.resetAvatarState();
                this.editFormVisible = false;
                this.handleQuery();
              };

              const saveVehiclesIfNeeded = (teacherId, teacherOkMsg) => {
                const items = this.buildTeacherVehiclePayload(this.editForm.vehicleList);
                if (!teacherId) {
                  closeEditAndRefresh(teacherOkMsg || "保存成功", "success");
                  return;
                }
                saveTeacherVehicles({
                  // long 标识保持字符串，避免超过 JS 安全整数后精度丢失。
                  teacherId: String(teacherId),
                  items: items,
                })
                  .then((r2) => {
                    if (r2 && r2.data && r2.data.success) {
                      closeEditAndRefresh(teacherOkMsg || r2.data.msg || "保存成功", "success");
                    } else {
                      closeEditAndRefresh(
                        (teacherOkMsg || "教师已保存") + "；" + ((r2 && r2.data && r2.data.msg) || "车牌保存失败"),
                        "warning"
                      );
                    }
                  })
                  .catch(() => {
                    closeEditAndRefresh((teacherOkMsg || "教师已保存") + "；车牌保存失败", "warning");
                  });
              };

              const res = await editTeacherMaster(para);
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                saveVehiclesIfNeeded(para.Id, res.data.msg);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.editLoading = false;
              }
            } catch (e) {
              this.editLoading = false;
              this.$message.error((e && e.message) || '头像上传失败');
            }
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      if (!this.ensureTeacherFormRequiredForSubmit(this.addForm, 'teacherAddTab')) return;
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          this.focusFormTabOnValidateFail('addForm', 'teacherAddTab', this.teacherAccountFieldProps());
          return;
        }
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(async () => {
            this.addLoading = true;
            try {
              const dids = (this.addForm.Dids || []).slice();
              if (!dids.length) {
                this.addLoading = false;
                this.$message.warning("请选择所属部门");
                return;
              }
              const headPhotoImage = await this.ensureHeadPhotoUploaded(dids);
              this.addForm.HeadPhotoImage = headPhotoImage;

              let para = Object.assign({}, this.addForm);
              para.Birthday =
                !para.Birthday || para.Birthday == ""
                  ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                  : util.formatDate.format(new Date(para.Birthday), "yyyy-MM-dd");

              para.Dids = dids;
              para.DepartmentId = dids[dids.length - 1];

              para.LiveTypeId = this.liveTypeId;
              delete para.vehicleList;

              const closeAddAndRefresh = (msg, msgType) => {
                this.addLoading = false;
                this.$message({ message: msg, type: msgType || "success" });
                this.$refs["addForm"].resetFields();
                this.addForm.vehicleList = [{ plateNo: "", vehicleType: "" }];
                this.resetAvatarState();
                this.addFormVisible = false;
                this.handleQuery();
              };

              const saveVehiclesIfNeeded = (teacherId, teacherOkMsg) => {
                const items = this.buildTeacherVehiclePayload(this.addForm.vehicleList);
                if (!teacherId) {
                  closeAddAndRefresh(teacherOkMsg || "保存成功", "success");
                  return;
                }
                saveTeacherVehicles({
                  // long 标识保持字符串，避免超过 JS 安全整数后精度丢失。
                  teacherId: String(teacherId),
                  items: items,
                })
                  .then((r2) => {
                    if (r2 && r2.data && r2.data.success) {
                      closeAddAndRefresh(teacherOkMsg || r2.data.msg || "保存成功", "success");
                    } else {
                      closeAddAndRefresh(
                        (teacherOkMsg || "教师已保存") + "；" + ((r2 && r2.data && r2.data.msg) || "车牌保存失败"),
                        "warning"
                      );
                    }
                  })
                  .catch(() => {
                    closeAddAndRefresh((teacherOkMsg || "教师已保存") + "；车牌保存失败", "warning");
                  });
              };

              const res = await addTeacherMaster(para);
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                const newId = res.data.response;
                saveVehiclesIfNeeded(newId, res.data.msg);
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            } catch (e) {
              this.addLoading = false;
              this.$message.error((e && e.message) || '头像上传失败');
            }
          });
        }
      });
    },

    /** 刷新教师同步范围树。最后更新：2026-09-02 */
    refreshSyncScopeTree() {
      this.syncScopeTreeNodes = this.resolveSyncScopeTreeNodes();
      this.syncScopeTreeExpandedKeys = this.syncScopeTreeNodes
        .map((node) => node && node.value)
        .filter((value) => value != null && value !== '')
        .map((value) => String(value));
    },
    /** 克隆组织树供弹窗 el-tree 使用。最后更新：2026-09-02 */
    cloneSyncScopeNode(node) {
      if (!node || typeof node !== 'object' || Array.isArray(node)) return node;
      return Object.assign({}, node, {
        children: (node.children || []).map((child) => this.cloneSyncScopeNode(child)),
      });
    },
    /** 解析内部通讯录同步范围树（与 InternalDept 一致，不含总平台）。最后更新：2026-09-02 */
    resolveSyncScopeTreeNodes() {
      const pane = this.$refs.departmentPane;
      const menuNodes = pane && Array.isArray(pane.menus)
        ? pane.menus.filter((node) => normalizeDeptId(node && node.value))
        : [];
      if (menuNodes.length) {
        return menuNodes.map((node) => this.cloneSyncScopeNode(node));
      }
      const root = pane && pane.originalTree;
      if (root) {
        const activeSchoolId = String(this.resolveSchoolId() || '');
        if (Array.isArray(root)) {
          for (let index = 0; index < root.length; index += 1) {
            const schoolNode = pane.findSchoolNode
              ? pane.findSchoolNode(root[index], activeSchoolId)
              : root[index];
            if (schoolNode && normalizeDeptId(schoolNode.value)) {
              return [this.cloneSyncScopeNode(schoolNode)];
            }
          }
          return root.map((node) => this.cloneSyncScopeNode(node));
        }
        const schoolNode = pane.findSchoolNode
          ? pane.findSchoolNode(root, activeSchoolId)
          : root;
        if (schoolNode) return [this.cloneSyncScopeNode(schoolNode)];
      }
      return [];
    },
    /** 初始化教师同步范围树：默认勾选当前左侧部门（学校根则不勾选）。最后更新：2026-09-02 */
    initSyncScopeTreeSelection() {
      this.$nextTick(() => {
        const tree = this.$refs.syncScopeTree;
        if (!tree) return;
        const currentId = String(this.currentDepartment && this.currentDepartment.value || '');
        const schoolId = String(this.resolveSchoolId() || '');
        if (currentId && schoolId && currentId !== '0' && currentId !== schoolId) {
          tree.setCheckedKeys([currentId]);
        } else {
          tree.setCheckedKeys([]);
        }
      });
    },
    /** 构建教师同步范围 payload。最后更新：2026-09-02 */
    buildTeacherSyncScopePayload() {
      const tree = this.$refs.syncScopeTree;
      if (!tree) return null;
      const checkedNodes = tree.getCheckedNodes(false, false);
      if (!checkedNodes.length) return null;
      const schoolId = String(this.resolveSchoolId() || '');
      if (checkedNodes.length === 1 && String(checkedNodes[0].value) === schoolId) {
        return { scopeType: 'School', scopeDepartmentIds: [] };
      }
      const scopeDepartmentIds = checkedNodes
        .map((node) => normalizeDeptId(node.value))
        .filter((id) => !!id);
      if (!scopeDepartmentIds.length) return null;
      return { scopeType: 'Department', scopeDepartmentIds };
    },
    openTaskCenterFromSync() {
      this.syncTypeDialogVisible = false;
      this.taskCenterVisible = true;
    },

    /**
     * 同步当前节点及子部门教师到天波平台。权限 Func 应为 syncTeacherToTb。最后更新：2026-09-01
     */
    syncTeacherToTb() {
      if (this.DepartmentId <= 0) {
        this.$message.error('请先在左侧选择要同步的部门或学校');
        return;
      }
      getDepartmentType({ id: this.DepartmentId }).then((res) => {
        const schoolInfo = res.data && res.data.success ? res.data.response : null;
        if (!schoolInfo || schoolInfo.IsSyncTb !== '1') {
          this.$message.warning('当前学校未启用天波对接，请在机构管理中开启');
          return;
        }
        this.$confirm(
          '确认将当前节点及子部门下的教师同步到天波平台吗？',
          '同步到天波平台',
          { type: 'warning' }
        ).then(() => {
          syncAllSubDeptTeacherToTb({ Id: this.DepartmentId }).then((syncRes) => {
            if (syncRes.data && syncRes.data.success) {
              this.$message.success(syncRes.data.msg || '已提交同步任务');
            } else {
              this.$message.error((syncRes.data && syncRes.data.msg) || '同步提交失败');
            }
          }).catch(() => {
            this.$message.error('同步请求失败');
          });
        }).catch(() => {});
      }).catch(() => {
        this.$message.error('获取学校天波配置失败');
      });
    },
    /** 兼容旧权限误配 syncStudentToTb（学生页 Func 名）。最后更新：2026-09-01 */
    syncStudentToTb() {
      this.syncTeacherToTb();
    },

    // 同步钉钉教师（与内部通讯录「后台同步任务」一致）。最后更新：2026-09-02
    syncTeacher() {
      if (!this.isDingTalkSchool) {
        this.$message.warning('仅钉钉学校可同步钉钉教师');
        return;
      }
      if (!normalizeDeptId(this.DepartmentId)) {
        this.$message.error('请先在左侧选择要同步的基础部门！');
        return;
      }
      this.syncScopeTreeNodes = [];
      this.syncScopeTreeExpandedKeys = [];
      this.syncScopeTreeKey += 1;
      this.syncTypeDialogVisible = true;
      this.$nextTick(() => {
        this.refreshSyncScopeTree();
        this.initSyncScopeTreeSelection();
      });
    },

    async handleSyncTeacher() {
      if (!this.isDingTalkSchool) {
        this.$message.warning('仅钉钉学校可同步钉钉教师');
        return;
      }
      const schoolId = this.resolveSchoolId();
      if (!schoolId) {
        this.$message.warning('未识别到当前节点所属学校');
        return;
      }
      const scopePayload = this.buildTeacherSyncScopePayload();
      if (!scopePayload) {
        this.$message.warning('请先勾选同步范围');
        return;
      }
      try {
        await this.$confirm(
          buildSyncScopeConfirmMessage(scopePayload, '教师'),
          '同步确认',
          { type: 'warning' }
        );
      } catch (e) {
        return;
      }
      this.syncLoading = 'Teacher';
      try {
        const res = await submitDingTalkSyncTask({
          SchoolDepartmentId: schoolId,
          ResourceType: 'Teacher',
          BigType: 0,
          ScopeType: scopePayload.scopeType,
          ScopeDepartmentIds: scopePayload.scopeDepartmentIds,
        });
        if (!res.data || !res.data.success) {
          this.$message({
            message: `${res.data && res.data.msg ? res.data.msg.replace(/\n/g, '<br>') : '同步任务提交失败'}`,
            type: 'error',
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        const taskId = res.data.response;
        this.$message.success(taskId ? `同步任务 ${taskId} 已提交` : '同步任务已提交');
        this.syncTypeDialogVisible = false;
        this.taskCenterVisible = true;
      } finally {
        this.syncLoading = '';
      }
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          liveTypeId: this.activeName,
          ...this.filters,
        };

        var fileName = "教师信息";
        if (this.currentDepartment && this.currentDepartment.label) {
          fileName += "-" + this.currentDepartment.label;
        }
        const response = await exportTeacherMaster(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
    // 导入：打开选择弹窗
    ImportCensus() {
      this.resetTeacherImportDialog();
      this.teacherImportDialogVisible = true;
    },
    resetTeacherImportDialog() {
      this.teacherImportFileRaw = null;
      this.teacherImportParsing = false;
      this.teacherImportUploadKey += 1;
    },
    onTeacherImportDialogClosed() {
      if (this.teacherImportKeepFileOnClose) {
        this.teacherImportKeepFileOnClose = false;
        return;
      }
      this.resetTeacherImportDialog();
    },
    backToTeacherImportSelect() {
      this.excelShow = false;
      this.teacherImportDialogVisible = true;
    },
    onTeacherImportFileChange(file) {
      this.teacherImportFileRaw = file && file.raw ? file.raw : null;
    },
    onTeacherImportFileRemove() {
      this.teacherImportFileRaw = null;
    },
    onTeacherImportExceed(files) {
      const nextFile = files && files[0];
      if (!nextFile) return;
      this.teacherImportUploadKey += 1;
      this.$nextTick(() => {
        this.teacherImportFileRaw = nextFile;
      });
    },
    // 下载教师主表导入模板。最后更新：2026-08-07
    downloadTeacherImportTemplate() {
      const headers = [
        "教师ID", "姓名", "卡号", "职务", "部门", "性别", "头像", "第三方ID", "关联校区"
      ];
      const sample = [
        "", "张老师", "", "教师", "语文组", "男", "", "", "主校区"
      ];
      const sheet = utils.aoa_to_sheet([headers, sample]);
      const book = utils.book_new();
      utils.book_append_sheet(book, sheet, "教师导入");
      writeFile(book, "教师主表批量导入模板.xlsx");
    },
    parseTeacherImportFile() {
      if (!this.teacherImportFileRaw) {
        this.$message.warning("请先选择 Excel 文件");
        return;
      }
      const file = this.teacherImportFileRaw;
      if (!/\.(xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return;
      }
      this.teacherImportParsing = true;
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = read(data, { type: "binary" });
          const wsname = workbook.SheetNames[0];
          const ws = utils.sheet_to_json(workbook.Sheets[wsname]);
          this.outputs = [];
          for (let i = 0; i < ws.length; i++) {
            this.outputs.push({
              TeacherId: ws[i]["教师ID"],
              TeacherName: ws[i]["姓名"],
              CardNumber: ws[i]["卡号"],
              Job: ws[i]["职务"],
              DepartmentName: ws[i]["部门"] || ws[i]["部门名称"] || "",
              Sex: ws[i]["性别"],
              HeadPhotoImage: ws[i]["头像"],
              ThirdPartyCode: ws[i]["第三方ID"],
              CampusNames: ws[i]["关联校区"]
            });
          }
          this.teacherImportParsing = false;
          this.teacherImportKeepFileOnClose = true;
          this.teacherImportDialogVisible = false;
          this.excelShow = true;
        } catch (e) {
          this.teacherImportParsing = false;
          this.$message.error("文件读取失败");
        }
      };
      fileReader.onerror = () => {
        this.teacherImportParsing = false;
        this.$message.error("文件读取失败");
      };
      fileReader.readAsBinaryString(file);
    },
    removeImport(scope) {
      this.outputs.splice(scope.$index, 1);
    },
    // 提交导入
    SavaImport() {
      const schoolDepartmentId = this.resolveSchoolId();
      if (!schoolDepartmentId) {
        this.$message.warning("请先在顶部选择学校");
        return;
      }
      this.listLoading = true;
      importTeacherMasterBatch({
        schoolDepartmentId: schoolDepartmentId,
        items: this.outputs,
      }).then((res) => {
        this.listLoading = false;
        const msg = (res.data && res.data.msg) || '';
        if (res.data && res.data.success) {
          this.excelShow = false;
          this.importResult = res.data.response || null;
          this.importResultVisible = true;
          this.handleQuery();
        } else {
          this.importResult = res.data && res.data.response ? res.data.response : null;
          this.importResultVisible = true;
          if (!this.importResult) {
            this.$message.error(msg || '导入失败');
          }
        }
      }).catch(() => {
        this.listLoading = false;
        this.$message.error('导入失败，请检查数据格式');
      });
    },
    formatBalance(value) {
      const num = Number(value || 0);
      return num.toFixed(2);
    },
    riskTagType(tag) {
      if (tag === "有余额") return "danger";
      if (tag === "有消费") return "warning";
      if (tag === "有任教") return "info";
      return "success";
    },
    async duplicateTeacherCheck() {
      if (this.DepartmentId <= 0) {
        this.$message({
          message: "请先在左侧选择部门后再检测！",
          type: "warning",
        });
        return;
      }

      this.duplicateDialogVisible = true;
      this.duplicateLoading = true;
      try {
        const res = await getDuplicateTeacherWarnings({ departmentId: this.DepartmentId });
        if (res.data.success) {
          this.duplicateGroups = res.data.response || [];
          this.duplicateActiveGroups = this.duplicateGroups.map(e => e.GroupKey);
          this.duplicateSummary.groupCount = this.duplicateGroups.length;
          this.duplicateSummary.teacherCount = this.duplicateGroups.reduce((sum, item) => sum + (item.DuplicateCount || 0), 0);
          if (this.duplicateGroups.length === 0) {
            this.$message.success("未发现重复教师");
          }
        } else {
          this.$message.error(res.data.msg || "检测失败");
        }
      } catch (e) {
        this.$message.error("检测失败，请稍后重试");
      } finally {
        this.duplicateLoading = false;
      }
    },
    removeDuplicateTeacher(item) {
      if (!item || !item.TeacherId) return;
      this.$confirm(`确认删除【${item.TeacherName}】(ID:${item.TeacherId}) 吗？`, "提示", {
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "正在校验关联业务并删除教师，请稍候…",
            background: "rgba(0, 0, 0, 0.7)",
          });
          removeTeacherMaster({ id: item.TeacherId })
            .then((res) => {
              if (res.data.success) {
                this.$message.success(res.data.msg || "删除成功");
                this.handleQuery();
                this.duplicateTeacherCheck();
              } else {
                this.$message.error(res.data.msg || "删除失败");
              }
            })
            .catch(() => {
              this.$message.error("删除失败，请稍后重试");
            })
            .finally(() => {
              loading.close();
            });
        })
        .catch(() => { });
    },
    migrateLocalAvatarToOss() {
      this.localAvatarMigrateVisible = true
    },
    onLocalAvatarMigrateDone() {
      this.handleQuery()
    },
    openHeadPhotoCompress() {
      this.headPhotoCompressVisible = true
    },
    onHeadPhotoCompressDone() {
      this.handleQuery()
    },
    async refreshOssAvatarMigrateEnabled() {
      const deptId = this.resolveSchoolId()
      if (!deptId) {
        this.ossAvatarEnabled = false
        this.updateMigrateButtonVisibility()
        return
      }
      try {
        const res = await getTeacherLocalAvatarMigrateStatus({ departmentId: String(deptId) })
        this.ossAvatarEnabled = !!(res.data.success && res.data.response && res.data.response.Enabled)
      } catch (e) {
        this.ossAvatarEnabled = false
      }
      this.updateMigrateButtonVisibility()
    },
    updateMigrateButtonVisibility() {
      const btn = (this.buttonList || []).find(item => String(item.Func || '').toLowerCase() === 'migratelocalavatartooss')
      if (btn) this.$set(btn, 'IsHide', !this.ossAvatarEnabled)
    },
  },
  watch: {
    '$store.state.activeSchoolId'(newSchoolId, oldSchoolId) {
      if (String(newSchoolId || '') === String(oldSchoolId || '')) return;
      const schoolId = this.resolveSchoolId();
      this.SchoolId = schoolId;
      this.DepartmentId = schoolId || 0;
      this.currentDepartment = schoolId ? {
        value: schoolId,
        label: this.$store.state.activeSchoolName || '',
        DeptOrgType: 'school',
      } : null;
      this.filters = {};
      this.page = 1;
      this.users = [];
      this.total = 0;
      this.multipleSelection = [];
      this.currentRow = null;
      this.campusOptions = [];
      const campusSearch = this.searchList.find(item => item.key === 'campusId');
      if (campusSearch) campusSearch.options = [];
      if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
        this.$set(this.$refs.toolbar.searchObj, 'campusId', null);
      }
      this.deptFormOptions = [];
      this._deptFormTreeSchoolId = '';
      this.liveTypeList = [];
      this.liveTypeId = "";
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.loadCampusOptions();
      this.refreshOssAvatarMigrateEnabled()
      this.loadCurrentSchoolSchType()
      if (schoolId) this.handleQuery();
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 仅预隐藏「同步钉钉*」，绝不动头像迁移 OSS
    ;(this.buttonList || []).forEach(btn => {
      if (this.isDingTalkSyncToolbarButton(btn)) {
        const func = String(btn.Func || '').toLowerCase()
        if (/migrate|compress|qrcode/.test(func)) return
        this.$set(btn, 'IsHide', true)
      }
    })
    if (!this.buttonList.some(item => item.Func === "handleDelUsers")) {
      this.buttonList.push({
        name: "批量删除",
        Func: "handleDelUsers",
        id: 994,
        IsHide: false,
        btnType: "danger",
      });
    }
    if (!this.buttonList.some(item => item.Func === "duplicateTeacherCheck")) {
      this.buttonList.push({ name: "重复检测", Func: "duplicateTeacherCheck", id: 997, IsHide: false, btnType: "warning" });
    }
    if (!this.buttonList.some(item => item.Func === 'migrateLocalAvatarToOss')) {
      this.buttonList.push({
        name: '头像迁移OSS',
        Func: 'migrateLocalAvatarToOss',
        id: 996,
        IsHide: true,
        btnType: 'warning'
      })
    }
    if (!this.buttonList.some(item => item.Func === 'openHeadPhotoCompress')) {
      this.buttonList.push({
        name: '头像压缩',
        Func: 'openHeadPhotoCompress',
        id: 995,
        IsHide: false,
        btnType: 'warning'
      })
    }
    this.refreshOssAvatarMigrateEnabled()
    this.loadCurrentSchoolSchType()
  },
};
</script>

<style scoped>
.sync-dept-hint {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 6px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}

.avatar-size-tip {
  margin-top: 8px;
  color: #606266;
  font-size: 12px;
  line-height: 1.2;
}

.avatar-size-tip.is-over {
  color: #f56c6c;
}

.avatar-wrapper {
  position: relative;
  width: 106.8px;
  height: 106.8px;
}

.avatar-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
  border-radius: 6px;
}

.avatar-wrapper:hover .avatar-mask {
  opacity: 1;
}

.avatar-mask i {
  font-size: 24px;
  cursor: pointer;
}

.campus-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;
  justify-content: center;
  min-height: 22px;
  line-height: 1;
}

.campus-tag {
  margin: 0 !important;
  height: 22px;
  line-height: 20px;
  padding: 0 7px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
  flex-shrink: 0;
}

.campus-empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: 22px;
  padding: 0 8px;
  border: 1px dashed #d1d5db;
  border-radius: 4px;
  font-size: 12px;
  color: #9ca3af;
  background: #f9fafb;
  line-height: 1;
}

.empty-text {
  color: #909399;
  font-style: italic;
}

.duplicate-tip {
  color: #606266;
  margin-bottom: 10px;
}

.duplicate-summary {
  margin-bottom: 10px;
}

.duplicate-summary .el-tag {
  margin-right: 8px;
}

.duplicate-collapse {
  max-height: 55vh;
  overflow-y: auto;
}

.duplicate-group-title {
  margin-right: 8px;
  font-weight: 600;
}

.tb-sync-table {
  width: 100%;
}

.tb-sync-dialog-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 36px;
  gap: 12px;
}

.tb-sync-dialog /deep/ .el-dialog__body {
  padding-top: 10px;
}

.tb-sync-dialog /deep/ .el-tabs__header {
  margin: 0 0 8px 0;
}

.user-form-tabs /deep/ .el-tabs__content {
  padding: 0;
  overflow: hidden;
}

.user-form-tab-pane {
  max-height: 52vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px 10px 4px;
  box-sizing: border-box;
}

.dept-hint {
  margin: 4px 0 0;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.teacher-table /deep/ .el-table__row td {
  vertical-align: middle;
}

.teacher-identity {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.teacher-avatar {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  border-radius: 10px;
  overflow: hidden;
  background: #eef3fb;
}

.teacher-avatar-fallback {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #3b6fd9;
  font-weight: 600;
  background: linear-gradient(145deg, #edf3ff, #dde8fb);
}

.teacher-identity-text {
  min-width: 0;
}

.teacher-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.teacher-name-row strong {
  font-size: 14px;
  color: #1f2937;
}

.teacher-meta {
  margin-top: 2px;
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.teacher-dept {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  vertical-align: middle;
}

.teacher-dept-name {
  color: #303133;
  line-height: 1.4;
  font-size: 13px;
  text-align: center;
  word-break: break-all;
}

.teacher-dept-name.is-unsynced {
  color: #c45656;
}

.dept-main-title {
  font-weight: 500;
  color: #303133;
}

.dept-sub-title {
  margin-top: 2px;
  font-size: 11px;
  color: #909399;
}

/* 教师列表所属部门查看链接按钮。参考 KqtScheduleType 样式规范。最后修改：2026-09-08 */
.teacher-dept-btn-wrap {
  margin-top: 3px;
  display: flex;
  justify-content: center;
}

.t-dept-link-btn {
  padding: 3px 8px;
  font-size: 12px;
  color: #2563eb;
  background-color: #eff6ff;
  border-radius: 4px;
  line-height: 16px;
  border: 1px solid #bfdbfe;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.t-dept-link-btn:hover,
.t-dept-link-btn:focus {
  color: #1d4ed8;
  background-color: #dbeafe;
  border-color: #93c5fd;
}

/* 教师内部部门查看弹窗样式。参考 KqtScheduleType 风格。最后修改：2026-09-08 */
.t-dept-view-dialog .el-dialog__body {
  padding: 16px 20px 10px;
}

.t-view-head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 16px;
  margin-bottom: 14px;
}

.t-view-head-item {
  font-size: 13px;
  color: #334155;
  display: inline-flex;
  align-items: center;
}

.t-view-head-item .label {
  color: #64748b;
}

.t-view-head-item .val {
  font-weight: 500;
  color: #0f172a;
}

.t-view-head-item .main-dept-badge {
  color: #2563eb;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.t-view-head-item .match-dept-badge {
  color: #e6a23c;
  font-weight: 600;
}

.t-view-head-item .count-badge {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 12px;
  font-size: 12px;
  background-color: #eff6ff;
  color: #2563eb;
  font-weight: 600;
}

.t-view-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.t-view-search-input {
  max-width: 260px;
}

.t-view-table-wrap {
  border-radius: 4px;
  overflow: hidden;
}

.t-view-table .dept-name-text {
  font-size: 13px;
  color: #1e293b;
  font-weight: 500;
}

.t-view-table .dept-role-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 500;
}

.t-view-table .dept-source-text {
  font-size: 12px;
  color: #94a3b8;
}

.t-view-empty {
  padding: 30px 0;
  color: #94a3b8;
  font-size: 13px;
  text-align: center;
}

.teacher-all-depts-card {
  padding: 10px 14px;
  background-color: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.all-depts-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.dept-all-tag {
  border-radius: 4px;
}

.tag-main-badge {
  margin-left: 2px;
  font-weight: bold;
}

.all-depts-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.teacher-creds,
.teacher-audit {
  line-height: 1.5;
  color: #303133;
}

.cred-label {
  display: inline-block;
  min-width: 32px;
  margin-right: 6px;
  color: #909399;
  font-size: 12px;
}

.teacher-profile {
  color: #606266;
  line-height: 1.5;
}

.teacher-sync-target {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px;
  color: #64748b;
  font-size: 12px;
}

.teacher-sync-target strong {
  min-width: 0;
  overflow: hidden;
  color: #334155;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.teacher-sync-target .el-tag {
  margin-left: auto;
}

.teacher-sync-scope-tree {
  overflow: hidden;
  margin-bottom: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.teacher-sync-scope-tree > header {
  padding: 10px 13px;
  border-bottom: 1px solid #eef2f7;
  background: #fbfcfe;
}

.teacher-sync-scope-tree > header strong,
.teacher-sync-scope-tree > header span {
  display: block;
}

.teacher-sync-scope-tree > header strong {
  color: #1e293b;
  font-size: 14px;
}

.teacher-sync-scope-tree > header span {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 12px;
}

.teacher-sync-scope-tree__body {
  height: 380px;
  padding: 8px 10px;
  overflow: auto;
}

.teacher-sync-tree__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 200px;
  color: #94a3b8;
  font-size: 13px;
}

.teacher-sync-tree__empty i {
  font-size: 28px;
  color: #cbd5e1;
}

.teacher-sync-notice {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 4px;
  padding: 9px 11px;
  border-radius: 7px;
  color: #64748b;
  background: #f8fafc;
  font-size: 12px;
  line-height: 1.5;
}

.teacher-sync-notice i {
  margin-top: 2px;
  color: #6090dc;
}

.teacher-sync-notice p {
  margin: 0;
}

.teacher-sync-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.teacher-sync-footer__hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #94a3b8;
  font-size: 12px;
}

.teacher-sync-footer__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.teacher-sync-dialog /deep/ .el-dialog__header {
  padding: 18px 22px 14px;
  border-bottom: 1px solid #e8edf3;
}

.teacher-sync-dialog /deep/ .el-dialog__body {
  padding: 17px 22px 10px;
}

.teacher-sync-dialog /deep/ .el-dialog__footer {
  padding: 13px 22px 18px;
  border-top: 1px solid #eef2f6;
}

/* 车牌列表超过 3 条时内部滚动，避免弹窗过高。最后更新：2026-08-30 */
.vehicle-list {
  width: 100%;
}

.vehicle-list.is-scrollable {
  max-height: 144px;
  overflow-y: auto;
  padding-right: 4px;
  margin-bottom: 4px;
}

.vehicle-row {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  align-items: center;
}

.vehicle-list .vehicle-row:last-child {
  margin-bottom: 0;
}

.vehicle-list-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 2px;
}

.vehicle-list-count {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}
</style>
